import type { FC } from "react";
import { styled } from "@kivra/react-components";
import { FadeInAndOut } from "../atoms/FadeInAndOut";
import { Instructions } from "./Instructions";

export const BannersMobile: FC = () => (
  <FadeInAndOut>
    <Container>
      <Instructions />
      <Image src="/assets/onboarding-registration.png" />
    </Container>
  </FadeInAndOut>
);

const Container = styled.div({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  padding: [0, "$spacing-32", "$spacing-48", "$spacing-32"],
});

const Image = styled.img({
  width: "100%",
  maxWidth: "400px",
});
